var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.url && _vm.internal)?_c('nuxt-link',{attrs:{"to":_vm.cleanUrl},nativeOn:{"click":function($event){return _vm.hideMenu.apply(null, arguments)}}},[_vm._t("default")],2):(_vm.url)?_c('a',{attrs:{"href":_vm.url}},[_vm._t("default")],2):_c('span',[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }